import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { buildMatchLink, type MatchParams } from '../../utils/matchParams';
interface ArticleCTABandProps {
  body: string;
  buttonLabel: string;
  /** Compact variant sits inside the article body; full sits at the end. */
  variant?: 'inline' | 'full';
  /** Pre-populates the match widget with this article's context. */
  match?: MatchParams;
}
export function ArticleCTABand({
  body,
  buttonLabel,
  variant = 'full',
  match
}: ArticleCTABandProps) {
  const to = buildMatchLink('/request-information', match);
  if (variant === 'inline') {
    return <aside className="bg-light border border-gray-200 rounded-xl p-6 sm:p-7" data-id="element-127" data-mp="tiscq2lghkop">
        <p className="text-gray-700 leading-relaxed mb-5" data-id="element-128" data-mp="okqxjsr5i5ii">{body}</p>
        <Link to={to} className="inline-flex items-center gap-2 bg-cta hover:bg-cta-dark text-white font-bold py-3 px-7 rounded-lg text-sm transition-colors duration-200" data-id="element-129" data-mp="kicf39re97rr">
          {buttonLabel}
          <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-130" data-mp="1va2olr85i6rg" />
        </Link>
        <p className="mt-3 text-xs text-gray-500" data-id="element-131" data-mp="201uedzjhg8gj">
          No cost to students. No obligation to enroll.
        </p>
      </aside>;
  }
  return <section className="bg-navy py-14" data-id="element-132" data-mp="1m8cwskacx5t5">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-133" data-mp="1qazu30psrixq">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-134" data-mp="2e1c7gr3ta7vp">
          Get Matched Now
        </h2>
        <p className="text-white/80 leading-relaxed mb-8" data-id="element-135" data-mp="2j0gkxtxrqrru">{body}</p>
        <Link to={to} className="inline-flex items-center gap-2 bg-cta hover:bg-cta-dark text-white font-bold py-3.5 px-10 rounded-lg text-sm transition-colors duration-200" data-id="element-136" data-mp="2izngx0q72gde">
          {buttonLabel}
          <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-137" data-mp="tlihs2wb6yn2" />
        </Link>
        <p className="mt-4 text-xs text-white/60" data-id="element-138" data-mp="tnv6cywko793">
          Matching costs students nothing. No obligation to enroll.
        </p>
      </div>
    </section>;
}